import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import BookingForm from '../../../core/common/booking/bookingForm';
import axios from 'axios';

interface PacoteDTO {
    id: number;
    titulo: string;
    precoBase: number;
    duracaoEmMinutos: number;
    fotoUrls: string[];
    idadeMinima: number; // 👈 adicionar aqui
}

const BASE_URL = process.env.REACT_APP_API_URL;

const FlightBooking = () => {
    const routes = all_routes;
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    const [reserva, setReserva] = useState<{
        motoristaId: number | null;
        data: string | null;
        horario: string | null;
        adultos: number;
        criancas: number;
    }>({
        motoristaId: null,
        data: null,
        horario: null,
        adultos: 1,
        criancas: 0,
    });

    const [packageId, setPackageId] = useState<number | null>(null);
    const [packageData, setPackageData] = useState<PacoteDTO | null>(null);

    useEffect(() => {
        if (id) {
            setPackageId(Number(id));

            const fetchPacote = async () => {
                try {
                    const { data } = await axios.get<PacoteDTO>(`${BASE_URL}/pacotes/${id}`);
                    setPackageData(data);
                } catch (err) {
                    console.error("Erro ao buscar pacote:", err);
                }
            };

            fetchPacote();
        }
    }, [id]);

    // Calcula preço total
    const precoTotal =
        packageData && reserva
            ? packageData.precoBase * (reserva.adultos + reserva.criancas)
            : 0;

    //Breadcrumb Data
    const breadcrumbs = [
        {
            label: 'Checkout Tour',
            link: routes.home1,
            active: false,
        },
        {
            label: 'Checkout Tour',
            active: true,
        },
    ];

    return (
        <div>
            <Breadcrumb
                title="Checkout Tour"
                breadcrumbs={breadcrumbs}
                backgroundClass="breadcrumb-bg-05"
            />

            {/* Page Wrapper */}
            <div className="content content-two">
                <div className="container">
                    <div className="row">
                        {/* Formulário de Booking */}
                        <div className="col-lg-8">
                            <BookingForm
                                packageId={packageId}
                                onReservaChange={setReserva}
                                idadeMinima={packageData?.idadeMinima ?? null}
                                tourDurationMinutes={packageData?.duracaoEmMinutos ?? 0}
                            />
                        </div>

                        {/* Review Order Details */}
                        <div className="col-lg-4">
                            <div className="card order-details theiaStickySidebar">
                                <div className="card-header">
                                    <div className="d-flex align-items-center justify-content-between header-content">
                                        <h5>Review Order Details</h5>
                                        <Link
                                            to={packageId ? `/flight-details/${packageId}` : "#"}
                                            className="rounded-circle p-2 btn btn-light d-flex align-items-center justify-content-center"
                                        >
                                            <span className="fs-16 d-flex align-items-center justify-content-center">
                                                <i className="isax isax-eye" />
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {!packageData && <p>Loading package details...</p>}

                                    {packageData && (
                                        <div>
                                            {/* Imagem principal */}
                                            {packageData.fotoUrls && packageData.fotoUrls.length > 0 && (
                                                <div className="mb-3 text-center">
                                                    <img
                                                        src={`${BASE_URL}${packageData.fotoUrls[0]}`} // pega só a primeira
                                                        alt={packageData.titulo}
                                                        className="img-fluid rounded shadow-sm"
                                                        style={{ maxHeight: "180px", objectFit: "cover" }}
                                                    />
                                                </div>
                                            )}

                                            {/* Título */}
                                            <h5 className="mb-3 text-primary">{packageData.titulo}</h5>

                                            {/* Preço total */}
                                            <div className="d-flex align-items-baseline mb-2">
                                                <h4 className="text-success mb-0">
                                                    ${precoTotal.toFixed(2)}
                                                </h4>
                                                <span className="text-muted ms-2">/ total</span>
                                            </div>

                                            {/* Quantidade de pessoas */}
                                            <p className="fs-14 text-gray-7 mb-1">
                                                {reserva.adultos} Adults, {reserva.criancas} Children
                                            </p>

                                            {/* Preço base por pessoa */}
                                            <p className="fs-14 text-gray-7 mb-0">
                                                <i className="isax isax-money me-1" /> ${packageData.precoBase} per person
                                            </p>

                                            {/* Duração */}
                                            <p className="fs-14 text-gray-7 mb-0">
                                                <i className="isax isax-timer me-1" /> {packageData.duracaoEmMinutos} minutes
                                            </p>
                                        </div>
                                    )}
                                </div>
                                <div className="text-end mt-3">
                                    <button
                                        className="btn btn-primary"
                                        onClick={async () => {
                                            if (!reserva.data || !reserva.horario || !reserva.motoristaId || !packageId) {
                                                alert("⚠️ Selecione motorista, data e horário antes de continuar!");
                                                return;
                                            }

                                            try {
                                                await axios.post(
                                                    `${BASE_URL}/pacotes/${packageId}/comprar`,
                                                    {
                                                        motoristaId: reserva.motoristaId,
                                                        dataReserva: reserva.data,
                                                        horaReserva: reserva.horario,
                                                        adultos: reserva.adultos,
                                                        criancas: reserva.criancas,
                                                    },
                                                    {
                                                        headers: {
                                                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                                                        },
                                                    }
                                                );
                                                alert("✅ Reserva realizada com sucesso!");

                                                navigate("/user/dashboard");
                                            } catch (err) {
                                                console.error("Erro ao reservar:", err);
                                                alert("❌ Erro ao realizar reserva, tente novamente.");
                                            }
                                        }}
                                    >
                                        Confirmar Reserva
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* /Review Order Details */}
                    </div>
                </div>
            </div>
            {/* /Page Wrapper */}
        </div>
    );
};

export default FlightBooking;